import { API_ENDPOINT } from "../../constants";
import { HTTP } from "../http";

export const LoanPaymentService = {
  save: (data: FormData) => {

    return HTTP.post<any, any>(`${API_ENDPOINT}operation/loan-payments`, data);
  },
  list: (loan: string) => {
    return HTTP.get<any, any>(`${API_ENDPOINT}operation/loan-payments/${loan}`);
  },
};
